import { Component, OnInit } from '@angular/core';
import { SEOService } from 'src/app/shared/seo.service';

interface Secenek { harf: string; metin: string; dogru?: boolean; }
interface Tur {
  n: string;
  g: string;
  s: Secenek[];
  r: string[];
}
interface Havuz {
  bas: string;
  havuz: [string, string][];
  not: string;
  kaynak: string;
  kok: string;
  tur: Tur[];
}

@Component({
  selector: 'app-index-online-learning',
  templateUrl: './index-online-learning.component.html',
  styleUrls: ['./index-online-learning.component.css']
})
export class IndexOnlineLearningComponent implements OnInit {
  appUrl = 'https://app.pratiu.com';
  aktifS: 'lgs' | 'tyt' | 'ayt' = 'lgs';
  aktifT = 0;

  veri: { [k: string]: Havuz } = {
    lgs: {
      bas: 'LGS havuzu',
      havuz: [
        ['Özgün soru', '1.240'],
        ['Etiketli kazanım', '512'],
        ['Üretilen türev soru', '46.800'],
        ['Öğretmen onaylı türev', '31.204']
      ],
      not: 'LGS kazanımlarına göre yazılmış özgün sorular. Türevler kökün kazanımını ve zorluk seviyesini korur.',
      kaynak: 'LGS · MATEMATİK · ÖZGÜN SORU',
      kok: 'Bir bahçıvan, 60 lale ve 90 sümbülü hiç artmayacak şekilde eşit sayıda çiçek içeren özdeş demetler hâlinde bağlayacaktır. En az kaç demet elde eder?',
      tur: [
        {
          n: 'Sayılar EBOB\'u koruyacak şekilde değiştirildi',
          g: 'Bir bahçıvan, 84 lale ve 126 sümbülü hiç artmayacak şekilde eşit sayıda çiçek içeren özdeş demetler hâlinde bağlayacaktır. En az kaç demet elde eder?',
          s: [{ harf: 'A', metin: '3' }, { harf: 'B', metin: '5', dogru: true }, { harf: 'C', metin: '6' }, { harf: 'D', metin: '10' }, { harf: 'E', metin: '21' }],
          r: ['M.8.1.2.1', 'zor', '95 sn', 'aynı kazanım']
        },
        {
          n: 'Aynı yapı, öğrencinin tanımadığı bir bağlama taşındı',
          g: 'Bir kütüphaneci, 60 roman ve 90 şiir kitabını hiç artmayacak şekilde eşit sayıda kitap içeren özdeş raflara dizecektir. En az kaç raf kullanır?',
          s: [{ harf: 'A', metin: '3' }, { harf: 'B', metin: '5', dogru: true }, { harf: 'C', metin: '6' }, { harf: 'D', metin: '15' }, { harf: 'E', metin: '30' }],
          r: ['M.8.1.2.1', 'orta', '80 sn', 'yeni bağlam']
        },
        {
          n: 'Çeldiriciler bu kazanımın en sık üç hatasından üretildi',
          g: 'Bir bahçıvan, 60 lale ve 90 sümbülü hiç artmayacak şekilde eşit sayıda çiçek içeren özdeş demetler hâlinde bağlayacaktır. En az kaç demet elde eder?',
          s: [
            { harf: 'A', metin: '2 · EBOB yerine bölen sayısı' },
            { harf: 'B', metin: '5', dogru: true },
            { harf: 'C', metin: '6 · EBOB\'un kendisi bölündü' },
            { harf: 'D', metin: '30 · EBOB cevap sanıldı' },
            { harf: 'E', metin: '180 · EKOK alındı' }
          ],
          r: ['M.8.1.2.1', 'zor', '110 sn', 'hata odaklı']
        },
        {
          n: 'Verilen ile istenen yer değiştirdi',
          g: 'Bir bahçıvan elindeki laleleri ve sümbülleri hiç artmayacak şekilde özdeş 5 demet hâlinde bağlamıştır. Her demette 12 lale ve 18 sümbül olduğuna göre bahçıvanın kaç sümbülü vardı?',
          s: [{ harf: 'A', metin: '60' }, { harf: 'B', metin: '72' }, { harf: 'C', metin: '90', dogru: true }, { harf: 'D', metin: '120' }, { harf: 'E', metin: '150' }],
          r: ['M.8.1.2.1', 'orta', '75 sn', 'ters kurgu']
        },
        {
          n: 'İkinci bir kazanım eklendi: oran-orantı',
          g: 'Bir bahçıvan, lale ve sümbülleri hiç artmayacak şekilde özdeş demetler hâlinde bağlamıştır. Demet sayısı en az olacak biçimde bağlandığında her demetteki lale sayısının sümbül sayısına oranı 2/3 olmaktadır. Toplam 150 çiçek varsa bahçıvan kaç lale kullanmıştır?',
          s: [{ harf: 'A', metin: '45' }, { harf: 'B', metin: '50' }, { harf: 'C', metin: '60', dogru: true }, { harf: 'D', metin: '75' }, { harf: 'E', metin: '90' }],
          r: ['M.8.1.2.1 + M.7.1.4.1', 'zor', '140 sn', 'çift kazanım']
        }
      ]
    },
    tyt: {
      bas: 'TYT havuzu',
      havuz: [
        ['Özgün soru', '1.880'],
        ['Etiketli kazanım', '740'],
        ['Üretilen türev soru', '58.400'],
        ['Öğretmen onaylı türev', '37.910']
      ],
      not: 'TYT temel matematik, Türkçe ve fen kazanımlarına göre yazılmış özgün sorular. Türevler soru süresini de korur.',
      kaynak: 'TYT · TEMEL MATEMATİK · ÖZGÜN SORU',
      kok: 'Bir işi A işçisi tek başına 12 günde, B işçisi tek başına 18 günde bitirmektedir. İkisi birlikte çalışırsa iş kaç günde biter?',
      tur: [
        {
          n: 'Süreler değişti, çözüm yöntemi aynı kaldı',
          g: 'Bir işi A işçisi tek başına 15 günde, B işçisi tek başına 10 günde bitirmektedir. İkisi birlikte çalışırsa iş kaç günde biter?',
          s: [{ harf: 'A', metin: '5' }, { harf: 'B', metin: '6', dogru: true }, { harf: 'C', metin: '6,5' }, { harf: 'D', metin: '12,5' }, { harf: 'E', metin: '25' }],
          r: ['MAT.9.2.1', 'orta', '100 sn', 'aynı kazanım']
        },
        {
          n: 'İşçi problemi, veri aktarımı bağlamına taşındı',
          g: 'Bir dosyayı X sunucusu tek başına 12 dakikada, Y sunucusu tek başına 18 dakikada aktarmaktadır. İkisi aynı anda çalışırsa aktarım kaç dakika sürer?',
          s: [{ harf: 'A', metin: '6' }, { harf: 'B', metin: '7,2', dogru: true }, { harf: 'C', metin: '7,5' }, { harf: 'D', metin: '15' }, { harf: 'E', metin: '30' }],
          r: ['MAT.9.2.1', 'orta', '105 sn', 'yeni bağlam']
        },
        {
          n: 'Çeldiriciler tipik toplama ve ortalama hatalarını hedefler',
          g: 'Bir işi A işçisi tek başına 12 günde, B işçisi tek başına 18 günde bitirmektedir. İkisi birlikte çalışırsa iş kaç günde biter?',
          s: [
            { harf: 'A', metin: '6 · sürelerin farkı yarılandı' },
            { harf: 'B', metin: '7,2', dogru: true },
            { harf: 'C', metin: '15 · ortalama alındı' },
            { harf: 'D', metin: '30 · süreler toplandı' },
            { harf: 'E', metin: '36 · EKOK alındı' }
          ],
          r: ['MAT.9.2.1', 'zor', '120 sn', 'hata odaklı']
        },
        {
          n: 'Bilinmeyen, ikinci işçinin süresine kaydırıldı',
          g: 'Bir işi A işçisi tek başına 12 günde bitirmektedir. A ve B birlikte çalıştıklarında iş 7,2 günde bittiğine göre B tek başına işi kaç günde bitirir?',
          s: [{ harf: 'A', metin: '9' }, { harf: 'B', metin: '15' }, { harf: 'C', metin: '18', dogru: true }, { harf: 'D', metin: '20' }, { harf: 'E', metin: '24' }],
          r: ['MAT.9.2.1', 'orta', '95 sn', 'ters kurgu']
        },
        {
          n: 'Yüzde kazanımı eklendi',
          g: 'Bir işi A işçisi tek başına 12 günde, B işçisi tek başına 18 günde bitirmektedir. İkisi birlikte 4 gün çalıştıktan sonra A ayrılıyor. İşin geri kalanı için B kaç gün daha çalışmalıdır?',
          s: [{ harf: 'A', metin: '5' }, { harf: 'B', metin: '6' }, { harf: 'C', metin: '7' }, { harf: 'D', metin: '8', dogru: true }, { harf: 'E', metin: '9' }],
          r: ['MAT.9.2.1 + MAT.9.1.3', 'zor', '150 sn', 'çift kazanım']
        }
      ]
    },
    ayt: {
      bas: 'AYT havuzu',
      havuz: [
        ['Özgün soru', '2.140'],
        ['Etiketli kazanım', '915'],
        ['Üretilen türev soru', '61.300'],
        ['Öğretmen onaylı türev', '34.780']
      ],
      not: 'AYT matematik ve fen kazanımlarına göre yazılmış özgün sorular. Türevler zorluk seviyesini korur; kolay türev üretmeye izin verilmez.',
      kaynak: 'AYT · MATEMATİK · ÖZGÜN SORU',
      kok: 'f(x) = x² − 4x + 7 fonksiyonunun en küçük değeri kaçtır?',
      tur: [
        {
          n: 'Katsayılar değişti, tepe noktası yöntemi korundu',
          g: 'f(x) = x² − 6x + 11 fonksiyonunun en küçük değeri kaçtır?',
          s: [{ harf: 'A', metin: '1' }, { harf: 'B', metin: '2', dogru: true }, { harf: 'C', metin: '3' }, { harf: 'D', metin: '5' }, { harf: 'E', metin: '11' }],
          r: ['MAT.10.3.2', 'orta', '85 sn', 'aynı kazanım']
        },
        {
          n: 'Cebirsel ifade, uygulamalı bir maliyet problemine dönüştü',
          g: 'Bir atölyenin günlük maliyeti C(x) = x² − 4x + 7 (bin TL) ile veriliyor; burada x üretilen ürün sayısıdır. Maliyet en az kaç bin TL olabilir?',
          s: [{ harf: 'A', metin: '2' }, { harf: 'B', metin: '3', dogru: true }, { harf: 'C', metin: '4' }, { harf: 'D', metin: '5' }, { harf: 'E', metin: '7' }],
          r: ['MAT.10.3.2', 'orta', '110 sn', 'yeni bağlam']
        },
        {
          n: 'Çeldiriciler tepe noktası ve diskriminant karışıklığını hedefler',
          g: 'f(x) = x² − 4x + 7 fonksiyonunun en küçük değeri kaçtır?',
          s: [
            { harf: 'A', metin: '−2 · tepe noktasının x\'i alındı' },
            { harf: 'B', metin: '2 · tepe x\'i cevap sanıldı' },
            { harf: 'C', metin: '3', dogru: true },
            { harf: 'D', metin: '7 · sabit terim alındı' },
            { harf: 'E', metin: '−12 · diskriminant alındı' }
          ],
          r: ['MAT.10.3.2', 'zor', '120 sn', 'hata odaklı']
        },
        {
          n: 'En küçük değer verildi, katsayı soruldu',
          g: 'f(x) = x² − 4x + k fonksiyonunun en küçük değeri 3 olduğuna göre k kaçtır?',
          s: [{ harf: 'A', metin: '3' }, { harf: 'B', metin: '4' }, { harf: 'C', metin: '5' }, { harf: 'D', metin: '7', dogru: true }, { harf: 'E', metin: '9' }],
          r: ['MAT.10.3.2', 'orta', '90 sn', 'ters kurgu']
        },
        {
          n: 'Türev kazanımı eklendi',
          g: 'f(x) = x² − 4x + 7 fonksiyonunun grafiğine, en küçük değerini aldığı noktadan 3 birim sağdaki noktada çizilen teğetin eğimi kaçtır?',
          s: [{ harf: 'A', metin: '2' }, { harf: 'B', metin: '3' }, { harf: 'C', metin: '4' }, { harf: 'D', metin: '6', dogru: true }, { harf: 'E', metin: '8' }],
          r: ['MAT.10.3.2 + MAT.12.1.2', 'zor', '160 sn', 'çift kazanım']
        }
      ]
    }
  };

  constructor(private seoService: SEOService) {}

  get havuz(): Havuz {
    return this.veri[this.aktifS];
  }

  get tur(): Tur {
    return this.havuz.tur[this.aktifT];
  }

  ngOnInit(): void {
    this.setMeta();
  }

  secSinav(id: 'lgs' | 'tyt' | 'ayt') {
    this.aktifS = id;
    this.aktifT = 0;
  }

  secTur(i: number) {
    this.aktifT = i;
  }

  setMeta() {
    const title = 'pratiu - Sürekli Öğrenme platformu';
    this.seoService.updateDescription(title);
    this.seoService.updateKeywords('Eğitim, Öğrenme, online eğitim, sürekli eğitim, bilgiyi taze tut, LGS, YKS');
    this.seoService.updateTitle(title);
  }
}
